import angular from 'angular';
import generalMobileSearch from './generalMobileSearch';

export default angular
  .module('components.generalMobileSearch', [])
  .component('generalMobileSearch', generalMobileSearch).name;
